import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

/* eslint-disable max-len */
export const ResponsibilitiesImage = <StaticImage src='../../images/vacancies/responsibilities.jpg' alt='' objectFit='cover' className='image' />
export const QualificationImage = <StaticImage src='../../images/vacancies/qualifications.jpg' alt='' objectFit='cover' className='image' />
export const NiceToHaveImage = <StaticImage src='../../images/vacancies/niceToHave.jpg' alt='' objectFit='cover' className='image' />
/* eslint-enable max-len */
